import GameObject from '../../../GameObject/GameObject';
import Game from '../../../Game';
import BasePopupHandler from './BasePopupHandler';
import UIItem, { IImageData } from '../../../Prototype/UI/UIItem';
import { TimerActions } from '../../../State/Timer/TimerActions';
import Point from '../../../Utility/Point';
import { TimerType } from '../../Timer/TimerTypes';
import BaseUISystem from '../BaseUISystem';
import UIImageComponent from '../../../Component/UI/Image';
import Text from '../../../Prototype/Text';
import { DEG_TO_RAD } from 'pixi.js';
import ElementComponent from '../../../Component/UI/Element';
import { GameActions } from '../../../State/Game/GameActions';
import UITextComponent from '../../../Component/UI/Text';
import DateHelper from '../../../Utility/DateHelper';
import { UIActions } from '../../../State/UI/UIActions';
import Element from '../../../Prototype/UI/Element';
import { ContextType } from '../../../State/Game/ContextType';
import { IGameState } from '../../../State/Game/IGameState';
import { IUIState } from '../../../State/UI/IUIState';
import { getFieldUnlockShare, getFieldUnlockShareKey, getWorldLang } from '../../../Constants/AvatarsAndCrops';
import { PopupID } from '../../../State/UI/PopupID';
import { IUIButtonData } from 'Prototype/UI/BaseElements/UIButton';
import { Platform } from 'Utility/Platform';
import { WorldDataHelper } from 'Utility/WorldDataHelper';
import { FieldToWorldMap } from '../../../../build/temp/WorldFieldMap';
import { LanguageData } from 'Utility/LocaleManager';
import { report } from 'report';
import LeaderboardHelper from '../LeaderboardHelper';

export default class FieldUnlockedHandler extends BasePopupHandler {
    private field: string;
    private buttons: IUIButtonData[] = [this.continueBtnParams, this.closeBtnParams];
    private worldNumber: number;
    constructor(uiSystem: BaseUISystem) {
        super(PopupID.FIELD_UNLOCKED_MENU, uiSystem);
    }

    protected createPopup(params?: any): void {
        this.worldNumber = Game.store.getState().worldState.worldNumber;
        this.clipShow = 'ShowCropUnlockShare';

        this.underlayParams.cacheKey = 'splash_harvest';
        // this.submitBtnParams.text.textLocalizationKey = 'Share';
        // this.submitBtnParams.text.style = Game.style.getStyle('popup.dark_blue_btn');
        // this.submitBtnParams.button.cacheKey = 'button_medium_blue';
        // this.submitBtnParams.background.layout.offsets = [200, -4, 200, -4];
        this.backgroundParams.layout.constrains = {
            heightMax: 740,
            heightMin: 740,
            widthMax: 1250,
            widthMin: 1250,
        };
        this.backgroundParams.cacheKey = 'blank';
        this.closeBtnParams.button.cacheKey = 'button_close';
        this.closeBtnParams.button.layout.anchors = [0.93, 0.12, 0.93, 0.12];

        this.configureShareButtonForNative();

        super.createPopup({
            buttons: this.buttons,
            title: null,
        });

        const playerIcon: GameObject = UIItem.createImage({
            name: 'player_avatar',
            cacheKey: 'avatar3',
            layout: {
                anchors: [0.765, 0.55, 0.765, 0.55],
                pivot: [0.5, 0.5],
                offsets: [-13, 0, -13, 0],
                scale: [0.95, 0.95],
                constrains: {
                    widthMax: 155,
                    widthMin: 155,
                    heightMax: 155,
                    heightMin: 155,
                },
            },
        });
        const base: GameObject = this.element.find('baseLayer');
        //base.getComponent<Renderable>(Renderable).container.alpha = 0;

        base.addChild(playerIcon);
        const newFieldText: GameObject = GameObject.Instantiate(Text, {
            name: 'new_field_txt',
            text: Game.locale.getText('NewField'),
            style: Game.style.getStyle('popup.new_field'),
            rotation: -25 * DEG_TO_RAD,
            x: 70,
            y: 110,
        });
        if (newFieldText.getComponent(UITextComponent)) {
            newFieldText.getComponent(UITextComponent).bounds = new Point(480, 240);
        }
        this.background.addChild(newFieldText);

        const fieldQuote: Element = GameObject.Instantiate(Element, {
            name: 'field_quote_txt',
            layout: {
                angle: -5,
                offsets: [-180, 220, -180, 220],
                anchors: [0.5, 0.5, 0.5, 0.5],
                pivot: [0.5, 0],
                scale: [1, 1],
            },
            components: [
                {
                    type: 'text',
                    data: {
                        style: Game.style.getStyle('popup.field_quote'),
                        bounds: [700, 300],
                        text: ' ',
                    },
                },
            ],
        });
        this.background.addChild(fieldQuote);
    }
    public *show(state: IUIState): IterableIterator<number> {
        let loadingComplete: boolean = false;
        this.field = state.params.id.split('_')[0];

        const { key: fieldShareKey, path: fieldSharePath } = getFieldUnlockShare(this.field);
        Game.resource.add(fieldShareKey, fieldSharePath);
        const fieldWorldNumber = FieldToWorldMap.get(this.field);

        const { key: worldLangKey, path: worldLangPath } = getWorldLang(fieldWorldNumber);
        if (!Game.resource.existsOrQueued(worldLangKey)) {
            Game.resource.add(worldLangKey, worldLangPath);
        }

        Game.resource
            .load()
            .then(() => {
                const locale = Game.resource.get<LanguageData>(worldLangKey) ?? {};
                Game.locale.setLanguagePartialData(locale);
                loadingComplete = true;
            })
            .catch(console.warn);

        let startTime: Date = DateHelper.now;

        while (!loadingComplete && DateHelper.timeSince(startTime) < 20000) {
            yield;
        }
        if (loadingComplete) {
            const iterator = super.show(state);
            this.system.coroutines.push({ iterator });
        } else {
            report('Failed to load FieldUnlocked popup', {
                once: true,
                sampleRate: 0.1,
                fingerprint: 'FailedToLoadPopup:FieldUnlockedHandler',
                tags: {
                    worldLangKey,
                    worldLangPath,
                    fieldShareKey,
                    fieldSharePath,
                    field: this.field,
                    worldNumber: fieldWorldNumber,
                },
            });
            UIActions.hidePopup(PopupID.FIELD_UNLOCKED_MENU);
        }
    }
    public onShow(params?: { id: string }) {
        super.onShow(params);

        const backgroundImageComponent: UIImageComponent = this.background.getComponent(UIImageComponent);
        const quote: GameObject = this.background.find('field_quote_txt');
        quote.getComponent(UITextComponent).text = Game.locale.getText(`${this.field}FieldQuote`);

        const base: GameObject = this.element.find('baseLayer');
        const playerAvatar: GameObject = base.find('player_avatar');
        const playerAvatarImageComponent = playerAvatar.getComponent(UIImageComponent);
        const fieldData = WorldDataHelper.getFieldDataByCropId(this.field);
        playerAvatar.getComponent(ElementComponent).anchors = fieldData.shares.field.anchors;
        LeaderboardHelper.setPlayerAvatar('player_avatar', Game.sdk.getAvatar(), playerAvatarImageComponent, 155);

        Game.resource.load().then(() => {
            if (backgroundImageComponent.gameObject && !backgroundImageComponent.gameObject.destroyed) {
                backgroundImageComponent.texture = getFieldUnlockShareKey(this.field);
            }
        });
    }

    private configureShareButtonForNative() {
        // if (Game.config.platform !== Platform.ANDROID && Game.config.platform !== Platform.IOS) {
        //     this.buttons.push(this.submitBtnParams);
        //     return;
        // }
        // On native platforms we omit the share button and center the continue button.
        this.continueBtnParams.background.layout.offsets = [0, 0, 0, 0];
    }

    protected toggleInteractables(value: boolean): void {
        // handles interactables itself
    }

    public onHidden(): void {
        this.system.scene.emit('TransitionCrops');
    }

    protected onSubmit(): void {
        super.onSubmit();

        GameActions.setContext(ContextType.SHARE_FIELD_UNLOCK, {
            field: this.field,
        });

        this.updateHarvestTimer();
    }
    protected onClose(): void {
        super.onClose();
        this.updateHarvestTimer();
    }
    protected updateHarvestTimer(): void {
        const state: IGameState = Game.store.getState();
        if (state.playerState.timers.get(TimerType.HARVEST) !== null) {
            TimerActions.updateTimer({
                timer: TimerType.HARVEST,
                time: null,
            });
        }
        Game.scene.getActiveScene().emit('TransitionCrops');
    }

    protected cropIconParams: IImageData = {
        name: 'crop_icon',
        cacheKey: 'blank',
        layout: {
            anchors: [0.5, 0.5, 0.5, 0.5],
            pivot: [0.5, 0.5],
            offsets: [0, 0, 0, 0],
            scale: [1, 1],
            constrains: {
                widthMax: 219,
                widthMin: 219,
                heightMax: 219,
                heightMin: 219,
            },
        },
    };
    protected cropIconBgParams: IImageData = {
        name: 'crop_icon_background',
        cacheKey: 'crop_bg_large',
        layout: {
            anchors: [0.5, 0.46, 0.5, 0.46],
            pivot: [0.5, 0.5],
            offsets: [0, 0, 0, 0],
            scale: [1, 1],
        },
    };
    protected textParams: any = {
        text: {
            name: 'field_unlocked_txt',
            textLocalizationKey: 'fieldUnlocked',
            style: {
                font: 'FrancoisOne',
                fill: '#f4f5c9',
                fontSize: '24px',
            },
            layout: {
                anchors: [0.5, 0.45, 0.5, 0.45],
                offsets: [0, 0, 0, 0],
                pivot: [0.5, 0.5],
            },
        },
        bg: {
            name: 'field_unlocked_txt_bg',
            layout: {
                anchors: [0.5, 0.72, 0.5, 0.72],
                offsets: [0, 0, 0, 0],
                pivot: [0.5, 0.5],
            },
            cacheKey: 'text_bg_long_green',
        },
    };
}
